import React from 'react';
import Loader from "./Loader";

import "./LoaderOverlay.scss";

/**
 * An overlay that renders on top of its parent element with a loading indicator.
 */
export default class LoaderOverlay extends React.Component {

  render() {
    return (
      <span className="LoaderOverlay">
        <span className="overlay"/>
        <Loader size='lg' block={true}/>
      </span>
    );
  }

}
